import { useEffect, useRef, useState } from "react";
import { CloseIcon } from "./CutomIcons";
import { useNavigate } from "react-router-dom";

import { api } from "../utils/apiHandler";
import { useTranslation } from "react-i18next";
import { isValidHandleFormat } from "../utils/handleValidation";

const CreateHandlePopup = ({ setShowPopup, isEdit = false }) => {
  const [handle, setHandle] = useState("");
  const [status, setStatus] = useState("idle"); // idle | checking | available | taken | invalid | saved
  const [error, setError] = useState("");
  const rawHandle = localStorage.getItem("handle");
  const handleLocal = rawHandle ? JSON.parse(rawHandle) : null;
  const { t } = useTranslation();
  const navigate = useNavigate();

  const inputRef = useRef(null);

  const handleInputChange = (e) => {
    const newValue = e.target.value;

    // Reset status and error when user types
    if (status !== "idle") setStatus("idle");
    if (error) setError("");

    // Check if the new value contains invalid characters
    if (newValue && !isValidHandleFormat(newValue) && newValue.length >= 4) {
      setStatus("invalid");
      setError("Handle can only contain letters, numbers, and underscores and must be at least 4 characters long.");
      // Still update the handle to show what they typed
      setHandle(newValue);
      return;
    }

    setHandle(newValue);
  };

  const handleCheckUserName = async () => {
    if (!handle.trim()) {
      setStatus("idle");
      setError("Handle is required.");
      return;
    }

    // Validate format before making API call
    if (!isValidHandleFormat(handle)) {
      setStatus("invalid");
      setError("Handle can only contain letters, numbers, and underscores.");
      return;
    }

    setStatus("checking");
    setError("");
    try {
      await api.get(`/users/check_handle?handle=${handle}`);
      setStatus("available");
    } catch (error) {
      console.log(error);
      setStatus("taken");
      setError("Handle already taken. Please try again.");
    }
  };

  const handleSave = async () => {
    try {
      setStatus("saving");
      const res = await api.patch(`/users/${handleLocal.user.id}`, { handle });
      localStorage.setItem(
        "handle",
        JSON.stringify({
          user: res.data,
          token: handleLocal.token,
        }),
      );
      setStatus("saved");
      setShowPopup(false);
      navigate("/sangati", { replace: true });
    } catch (error) {
      console.log(error);
      setStatus("idle");
      setError(error.response.data.errors[0]);
    }
  };

  const reset = () => {
    setHandle("");
    setStatus("idle");
    setError("");
  };

  useEffect(() => {
    if (handleLocal.user.handle) {
      setHandle(handleLocal.user.handle);
      if (isEdit) setStatus("idle");
      else setStatus("available");
    }
    if (inputRef.current) inputRef.current.focus();
  }, [handleLocal.user.handle, isEdit]);

  return (
    <div
      onClick={() => {
        if (isEdit) setShowPopup(false);
      }}
      className="fixed top-0 left-0 bg-bg-grey/80 h-screen w-screen z-50 flex items-start pt-[10vh] justify-center"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="w-[90%] max-w-[320px] bg-white85 border-div rounded-[10px] p-3 pb-5 text-black relative"
      >
        {isEdit && (
          <div
            className="absolute left-1/2 -translate-x-1/2 -top-6 -translate-y-1/2"
            onClick={() => setShowPopup(false)}
          >
            <img src="/icons/Sangati/cancel.svg" alt="" className="scale-90" />
          </div>
        )}
        <div className="flex justify-between items-start">
          {isEdit ? (
            <div>
              <h6 className="font-bold text-20">{t("sangatiHandle")} </h6>
              <h6 className="font-bold text-12">{t("editHandle")} </h6>
            </div>
          ) : (
            <div>
              <h6 className="font-bold text-16">{t("createHandleTitle")}:</h6>
            </div>
          )}
        </div>

        <div className="relative mt-2 ">
          <input
            ref={inputRef}
            type="text"
            value={handle}
            onChange={handleInputChange}
            className={`px-2 outline-[#C11E69] w-full rounded-[10px] border-2 ${
              status === "available"
                ? "border-[#10514233]"
                : status === "invalid"
                  ? "border-red-300"
                  : "border-[#00000020]"
            } bg-white h-[50px] text-16`}
            disabled={
              status === "checking" || status === "saving" || status === "saved"
            }
          />
          {(status === "taken" || status === "invalid") && (
            <button
              className="absolute size-[20px] cursor-pointer text-sangati-orange right-3 top-1/2 -translate-y-1/2"
              onClick={reset}
            >
              <CloseIcon />
            </button>
          )}
          {status === "available" && (
            <div className="absolute size-[20px]  right-3 top-1/2 -translate-y-1/2">
              <img alt="check" className="" src="/icons/Sangati/checkbox.svg" />
            </div>
          )}
        </div>

        <div className="h-6 text-center">
          {status === "available" ? (
            <span className="text-10 text-sangati-green font-bold">
              {t("handleAvailable")}
            </span>
          ) : (
            <span className="text-10 text-sangati-orange font-bold">
              {error}
            </span>
          )}
        </div>

        <div className="mt-7 flex justify-center">
          {status === "available" ? (
            <button className="btn-green" onClick={handleSave}>
              {status === "saving" ? `${t("save")}...` : t("save")}
            </button>
          ) : (
            <button className="btn-green" onClick={handleCheckUserName}>
              {status === "checking" ? `${t("check")}...` : t("check")}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default CreateHandlePopup;
